import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { AuthContext } from "../../context/AuthContext";
import Dashboard from "../../components/Dashboard/Dashboard";
import "./Contacts.css";
import MenuTop from "../../components/MenuTop/MenuTop";
import PdfEditor from "../../components/PdfEditor/PdfEditor";
import TableComponent from "../../components/TableComponent/TableComponent";
import { DocumentTypeContext } from "../../context/DocumentContext";
import { useNavigate } from "react-router-dom";
import ModalConfirm from "../../components/ModalConfirm/ModalConfirm";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ModalAddContact from "../../components/ModalAddContact/ModalAddContact";
import { ContactContext } from "../../context/ContactContext";
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import TableComponentOther from "../../components/TableComponentOther/TableComponentOther";
const Contacts = () => {
  const { objUserTk } = useContext(AuthContext);
  const {
    getContact,
    tableContacts,
    totalContats,
    getContactsByUserId,
    deleteContact,
  } = useContext(ContactContext);
  const navigate = useNavigate();
  const [openModalDelete, setOpenModalDelete] = useState({
    open: false,
    idDelete: "",
  });
  const [openModal, setOpenModal] = useState(false);

  const headCells: readonly any[] = [
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "Nome",
    },
    {
      id: "email",
      numeric: false,
      disablePadding: false,
      label: "E-mail",
    },
    {
      id: "phoneNumber",
      numeric: true,
      disablePadding: false,
      label: "Telefone",
    },
    {
      id: "",
      numeric: false,
      disablePadding: false,
      label: "",
    },
  ];

  const editItem = async (id: any) => {
    await getContact(id);
    setOpenModal(true);
  };

  const removeItem = async () => {
    await deleteContact(openModalDelete.idDelete);
    setOpenModalDelete({ open: false, idDelete: "" });
  };

  const getContactsByUserIdPage = async (page: number) => {
    await getContactsByUserId(page);
  };

  useEffect(() => {
    const getData = async () => {
      await getContactsByUserId(1);
    };
    getData();
  }, []);

  return (
    <>
      <LoadingSpinner />

      <MenuTop />

      <div
        className="mt-3 ml-3 mr-2 pt-4 pb-4 pl-4 d-flex"
        style={{
          height: "100%",
          backgroundColor: "#fff",
          gap: "20px",
          flexDirection: "column",
          borderRadius: "5px",
        }}
      >
        <div className="d-flex" style={{ alignItems: "center", gap: "17px" }}>
          <span className="title-page-document">MEUS CONTATOS</span>
          <label
            className="icon-upload-document"
            onClick={() => setOpenModal(true)}
          >
            <PersonAddIcon style={{ color: "#fff", cursor: "pointer" }} />
          </label>
        </div>

        <hr className="my-2" style={{ color: "#DDD", width: "100%" }} />
        {tableContacts?.length > 0 && (
          <>
            <div key={tableContacts?.map((item) => item.id).join("-")}>
              <TableComponentOther
                showId={false}
                page={0}
                rowsPerPage={10}
                headCells={headCells}
                rows={tableContacts}
                editItem={editItem}
                removeItem={(id: any) =>
                  setOpenModalDelete({
                    open: true,
                    idDelete: id,
                  })
                }
              />
            </div>
            <div className="d-flex justify-content-end pb-2 pr-2">
              <PaginationMaterial
                onChange={(e: any, page: number) =>
                  getContactsByUserIdPage(page || 0)
                }
                count={totalContats}
              />
            </div>
          </>
        )}
        {tableContacts.length === 0 && (
          <TableComponent headCells={headCells} rows={[]} />
        )}
      </div>
      <ModalConfirm
        openModal={openModalDelete.open}
        closeModal={() => setOpenModalDelete({ open: false, idDelete: "" })}
        handleConfirm={removeItem}
      />

      <ModalAddContact
        openModal={openModal}
        closeModal={() => setOpenModal(false)}
      />
    </>
  );
};

export default Contacts;
